// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_TOP_MARGIN_IN_PIXELS = -50;
